import React from "react";
import { Box } from "@mui/material";
import { capitalize } from "lodash";
import { ProgramStatus } from "../../constants";
import MinimizedTooltip from "../tooltip/MinimizedTooltip";
import { colorSystem } from "../../theme";

export interface ProgramStatusIndicatorProps {
  status: ProgramStatus | string;
}

const STATUS_CONFIG: Record<string, { color: string; tooltip: string }> = {
  [ProgramStatus.DRAFT]: {
    color: colorSystem.programStatus.draft,
    tooltip: "Clients won't see the program",
  },
  [ProgramStatus.ARCHIVED]: {
    color: colorSystem.programStatus.archived,
    tooltip: "Program is no longer active",
  },
};

export function ProgramStatusIndicator({
  status,
}: ProgramStatusIndicatorProps) {
  const normalizedStatus = status?.toString().toUpperCase();
  const config = STATUS_CONFIG[normalizedStatus];

  if (!config) {
    return null;
  }

  const label = capitalize(status?.toString().toLowerCase());

  return (
    <MinimizedTooltip title={config.tooltip} placement="right">
      <Box
        component="span"
        sx={{
          display: "inline-block",
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          backgroundColor: config.color,
          color: "#fff",
          fontSize: "0.75rem",
          fontWeight: 700,
          cursor: "default",
          mb: 1,
        }}
      >
        {label}
      </Box>
    </MinimizedTooltip>
  );
}
